import React from 'react';
import { Col, InformationalLegends, Row } from '@wyz/ui';
import { Trans } from '~/common/context';
import { DebugReport } from '~/purchase/types';

interface DebugSummaryProps {
  debugReport: DebugReport;
}

export const DebugSummary: React.FC<DebugSummaryProps> = ({ debugReport }) => {
  return (
    <Row>
      <Col>
        <InformationalLegends.Container>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.purchase.debug.summary.supplier_template' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='supplier-template-value'>
              {debugReport.supplierTemplate || '-'}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.purchase.debug.summary.brand_template' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='brand-template-value'>
              {debugReport.brandTemplate || '-'}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.purchase.debug.summary.setting_template' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='setting-template-value'>
              {debugReport.settingTemplate || '-'}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.purchase.debug.summary.redistribution_brand_template' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='redistribution-brand-template-value'>
              {debugReport.redistributionBrandTemplate || '-'}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.purchase.debug.summary.redistribution_supplier_template' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='redistribution-supplier-template-value'>
              {debugReport.redistributionSupplierTemplate || '-'}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.purchase.debug.summary.ranking_model' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='ranking-model-value'>
              {debugReport.rankingModelName || '-'}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
        </InformationalLegends.Container>
      </Col>
      <Col>
        <InformationalLegends.Container>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.purchase.debug.summary.reference_frame' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='reference-frame-value'>
              {debugReport.referenceFrame || '-'}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.purchase.debug.summary.alternative_supplier_price_frame_type' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='alternative-supplier-price-frame-type-value'>
              {debugReport.alternativeSupplierPriceFrameType || '-'}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.purchase.debug.summary.wholesaler_price_frame_type' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='wholesaler-price-frame-type-value'>
              {debugReport.wholesalerPriceFrameType || '-'}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.purchase.debug.label.errors' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='errors-value'>
              <span className='text-danger-text'>
                {debugReport.errors.join(', ') || '-'}
              </span>
            </InformationalLegends.Value>
          </InformationalLegends.Row>
        </InformationalLegends.Container>
      </Col>
    </Row>
  );
};
